'use strict';

export default function useCDNUrl(url) {
    const libCdnString = RivalIQ.libCdnString || '';
    const cdnVersion = RivalIQ.cdnVersion || '';

    return `${libCdnString}${url}${cdnVersion}`;
}
